var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnLink = function SvgIcnLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.2419C9.22731 11.4819 9.49862 11.6726 9.79805 11.8028C10.0975 11.933 10.419 12 10.7438 12C11.0686 12 11.3901 11.933 11.6896 11.8028C11.989 11.6726 12.2603 11.4819 12.4876 11.2419L15.2777 8.35541C15.7402 7.87694 16 7.228 16 6.55134C16 5.87468 15.7402 5.22574 15.2777 4.74727C14.8152 4.2688 14.1879 4 13.5339 4C12.8798 4 12.2526 4.2688 11.7901 4.74727L11.4413 5.10808",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8.75808C10.7727 8.51807 10.5014 8.32739 10.2019 8.19722C9.90252 8.06705 9.58099 8 9.2562 8C8.9314 8 8.60988 8.06705 8.31045 8.19722C8.01102 8.32739 7.7397 8.51807 7.51239 8.75808L4.72231 11.6446C4.25982 12.1231 4 12.772 4 13.4487C4 14.1253 4.25982 14.7743 4.72231 15.2527C5.18479 15.7312 5.81206 16 6.46611 16C7.12016 16 7.74743 15.7312 8.20991 15.2527L8.55868 14.8919",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_link.3e1cd9e6.svg";
export { ForwardRef as ReactComponent };